/** Role that may see and open the administration pages (mirrors backend `roles.ADMIN`). */
export const ADMIN_ROLE = "admin";

export const ADMIN_NAV = [
  { to: "/admin/sources", label: "Quellen" },
  { to: "/admin/templates", label: "Vorlagen" },
  { to: "/admin/senders", label: "Absender" },
  { to: "/admin/users", label: "Benutzer" },
  { to: "/admin/api-keys", label: "API-Schlüssel" },
  { to: "/admin/audit", label: "Audit-Log" },
];
